module.exports = __webpack_public_path__ + "img/stickers_0010_map.58a476b3.png";